import PaddedMaxWidthContainer from "components/layout/PaddedMaxWidthContainer";
import { extendClassName } from "utils/common";
import styles from "./Page.module.css";

interface IDrawPage {
    children: React.ReactNode;
}

const DrawPage = ({ children }: IDrawPage) => {
    return (
        <PaddedMaxWidthContainer additionalClassName={extendClassName(styles.pageContainer)}>
            {children}
        </PaddedMaxWidthContainer>
    )
}

export default DrawPage;